export const ADDITIONAL_UNITS_PICKER = 'additional-units-picker';
export const CLICKED_LINK = 'clicked-link';
export const MODAL_INTERACTION = 'modal-interaction';
export const NAVIGATION_CLICK = 'navigation-click';
export const TALK_TO_SALES_CLICK = 'talk-to-sales-click';
export const BUY_NOW_BUTTON_CLICK = 'buy-now-button-click';
export const PRODUCT_CLICK = 'product-click';
export const BUTTON_CLICK = 'button-click';
export const SCROLL_INTERACTION = 'scroll-interaction';
export const FAQ_INTERACTION = 'faq-interaction';
export const HOVER_INTERACTION = 'hover-interaction';
export const PAGE_VIEW = 'pageView';